<oth-card [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate" [headerTemplate]="headerTemplate"
          class="activity-history-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <div class="header">
      <p class="title">{{ title }}</p>
    </div>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <div class="activity-content">
        <ng-container *ngFor="let j of days">
          <div [class]="getChartItemClass(j)" class="day">
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <div class="footer">
      <app-color-chart></app-color-chart>
    </div>
  </ng-template>
</oth-card>
